import * as React from 'react';

export const Header: React.FC<{
  isLoading: boolean;
  isListOfLabels: boolean;
  itemCount?: number;
  labelQuantity?: number;
  itemDescription?: string;
}> = ({ isLoading, isListOfLabels, itemDescription, itemCount, labelQuantity }) => {
  if (isLoading) {
    return <>Print label</>;
  }
  if (isListOfLabels) {
    return (
      <>
        Print label queue - <var>{itemCount}</var> items, <var>{labelQuantity} </var>labels
      </>
    );
  }
  return (
    <>
      Print label for <var>{itemDescription}</var>
    </>
  );
};
